import { BASE_SERVICE_URI } from '../../constants/ApiConstants';
import { registerQuery, useQuery } from '../../utils/DataFetchingClient';
import { http } from '../http';
const GET_PORTAL_INFORMATION = registerQuery({
  fieldName: 'portalInfo',
  args: ['portalId'],
  fetcher: ({
    portalId
  }) => http.get(`${BASE_SERVICE_URI}/assignments/v1/portal/${portalId}`)
});
export const usePortal = ({
  portalId,
  skip
}) => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_PORTAL_INFORMATION, {
    skip,
    variables: {
      portalId
    }
  });
  return {
    portal: data,
    portalLoading: loading,
    portalError: error
  };
};